module.exports = __webpack_public_path__ + "img/zb3.974d8115.png";